import { FC } from "react";
import { Button } from "@/components/ui/button";
import { cn } from "@/lib/utils";

export interface NotFoundFallbackProps {
  onGoHome?: () => void;
  className?: string;
}

const NotFoundFallback: FC<NotFoundFallbackProps> = ({
  onGoHome,
  className,
}) => {
  const goHome = onGoHome ?? ((): void => {
    window.location.hash = "#/";
    window.location.reload();
  });

  return (
    <div
      className={cn(
        "flex min-h-[50vh] flex-col items-center justify-center gap-6 p-6",
        className
      )}
    >
      <div className="flex max-w-md flex-col items-center gap-4 text-center">
        <h1 className="text-xl font-semibold text-foreground">
          Page non trouvée
        </h1>
        <p className="text-sm text-muted-foreground">
          Le lien que vous avez suivi n&apos;existe pas ou a été déplacé.
        </p>
      </div>
      <div className="flex flex-wrap items-center justify-center gap-3">
        <Button
          onClick={goHome}
          variant="default"
          data-testid="notfound-go-home"
        >
          Revenir à l&apos;accueil
        </Button>
        <Button
          variant="ghost"
          asChild
          data-testid="notfound-support"
        >
          <a
            href="tel:0800000000"
            className="inline-flex items-center justify-center gap-2"
          >
            Contacter le support
          </a>
        </Button>
      </div>
    </div>
  );
};

export default NotFoundFallback;
